<template>
  <Teleport to="body">
    <div v-if="modalConfig.show" class="modal-backdrop" @click="closeModal()">
      <div class="modal-content-base">
        <div class="modal-content" @click.stop>
          <div class="modal-header" v-if="modalConfig.title">
            <component :is="modalConfig.title" v-if="isVNode(modalConfig.title)" />
            <h3 v-else class="modal-title">{{ modalConfig.title }}</h3>
          </div>

          <div class="modal-body" v-if="modalConfig.content">
            <component
              :is="modalConfig.content"
              v-if="isVNode(modalConfig.content) || typeof modalConfig.content === 'function'" />
            <template v-else>{{ modalConfig.content }}</template>
          </div>

          <div class="modal-footer">
            <component :is="modalConfig.footer" v-if="modalConfig.footer" />
            <template v-else-if="modalConfig.buttons?.length">
              <button
                v-for="(btn, index) in modalConfig.buttons"
                :key="index"
                :class="btn.class"
                @click="btn.onClick">
                <img :src="getImageUrl('modal_button_prefix.png')" class="modal-button-prefix" />{{
                  btn.text
                }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { isVNode } from 'vue';
import { useModal } from '@/hooks/modal/useModal';
import { getImageUrl } from '@/utils';

const { modalConfig, closeModal } = useModal();
</script>

<style lang="scss">
.modal-backdrop {
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modal-content-base {
  width: 86%;
  max-height: 60vh;
  border-width: 0px 1px;
  border-style: solid;
  border-color: #fff7ed;
  border-radius: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: rgba(143, 107, 85, 0.7);
  mix-blend-mode: normal;
  border: 1px solid #ffefd8;
  box-shadow: inset 0px 0px 6.8px 2px rgba(255, 255, 232, 0.25);
  border-radius: 20px;
  font-family: AlibabaPuHuiTi;
  font-weight: 600;
  font-size: 16px;
  color: rgba(251, 247, 227, 0.85);

  width: 97%;
  max-height: 60vh;
  overflow-y: auto;
  z-index: 100000;

  padding-top: 16px;
}

.modal-tips {
  font-size: 12px;
  margin-top: 12px;
  padding-left: 25%;
}

.modal-header {
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0 auto;
  margin-bottom: 16px;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.2s;
}

.modal-body {
  padding: 0 18px;
  margin-bottom: 20px;
  text-align: center;
}

.modal-footer {
  padding: 16px;
  padding-top: 0;
  display: flex;
  justify-content: space-evenly;
}

.modal-footer button {
  position: relative;
  padding: 4px 12px 4px 6px;
  background: rgba(143, 107, 85, 0.7);
  mix-blend-mode: normal;
  border: 0.5px solid #ffefd8;
  box-shadow: inset 0px 0px 6.8px 2px rgba(255, 255, 232, 0.25);
  border-radius: 20px;
  color: #fbf7e3;
  font-size: 15px;
  font-family: AlibabaPuHuiTi;
}

.modal-footer .modal-main-btn {
  box-shadow: inset 0px 0px 6.8px 2px rgba(255, 173, 114, 0.56);
}

.modal-button-prefix {
  width: 8.95px;
  height: 8.77px;
  margin-right: 4px;
}
</style>
